import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import axios from "axios";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from '../apiConfig';

const BetSummery = () => {

  const [loading, setLoading] = useState(true);
  const [gameData, setGameData] = useState([]);
  const [summary, setSummary] = useState({
    totalWin: 0, totalBet: 0, totalRefund: 0, netProfitLoss: 0, totalCount: 0
  });
  // ✅ NEW: provider summary state
  const [providerSummary, setProviderSummary] = useState([]);
  const [providerSort, setProviderSort] = useState({ key: 'totalBet', direction: 'desc' });

  const [pageCount, setPageCount] = useState(1);
  const [activeRange, setActiveRange] = useState('today');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [sortConfig, setSortConfig] = useState({ key: "createdAt", direction: "desc" });
  const currentPage = useRef(1);
  const limit = 50;

  const [gameName, setGameName] = useState('');
  const [provider, setProvider] = useState('');

  // ── Tabs ──────────────────────────────────────────────────────────────────
  const [activeTab, setActiveTab] = useState('provider'); // 'provider' | 'detail'

  const toLocalDateString = (d) => {
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // ✅ Fix stale closure: accept searchGameName & searchProvider as params
  const fetchData = async (start, end, pageOnly = false, searchGameName = gameName, searchProvider = provider) => {
    setLoading(true);
    try {
      const response = await axios.get(`${apiConfig.baseURL}/api/agent/casinoSummery`, {
        params: {
          startDate:  start || undefined,
          endDate:    end || undefined,
          page:       currentPage.current,
          limit,
          skipSummary: pageOnly ? 'true' : 'false',
          gameName:   searchGameName || undefined,
          provider:   searchProvider || undefined
        }
      });

      setGameData(response.data.data || []);

      if (!pageOnly) {
        setSummary({
          totalWin:      response.data.totalWin || 0,
          totalBet:      response.data.totalBet || 0,
          totalRefund:   response.data.totalRefund || 0,
          netProfitLoss: response.data.netProfitLoss || 0,
          totalCount:    response.data.totalCount || 0
        });
        // ✅ NEW: set provider summary
        setProviderSummary(response.data.providerSummary || []);
      }

      setPageCount(response.data.pageCount || 1);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    currentPage.current = 1;
    fetchData(startDate, endDate, false, gameName, provider);
  };

  // ✅ Fix: pass empty strings directly, no setTimeout needed
  const handleClearSearch = () => {
    setGameName('');
    setProvider('');
    currentPage.current = 1;
    fetchData(startDate, endDate, false, '', '');
  };

  const getDateRange = (range) => {
    const now = new Date();
    const todayStr = toLocalDateString(now);
    if (range === 'today') return { start: todayStr, end: todayStr };
    if (range === 'weekly') {
      const start = new Date(now);
      start.setDate(now.getDate() - 7);
      return { start: toLocalDateString(start), end: todayStr };
    }
    if (range === 'monthly') {
      const start = new Date(now.getFullYear(), now.getMonth(), 1);
      return { start: toLocalDateString(start), end: todayStr };
    }
    return { start: '', end: '' };
  };

  useEffect(() => {
    const { start, end } = getDateRange('today');
    setStartDate(start);
    setEndDate(end);
    fetchData(start, end);
  }, []);

  const handleRangeClick = (range) => {
    setActiveRange(range);
    if (range === 'custom') return;
    const { start, end } = getDateRange(range);
    setStartDate(start);
    setEndDate(end);
    currentPage.current = 1;
    fetchData(start, end, false, gameName, provider);
  };

  // ✅ Fix: pageOnly = true to skip summary re-fetch on page change
  const handlePageClick = (e) => {
    currentPage.current = e.selected + 1;
    fetchData(startDate, endDate, true, gameName, provider);
  };

  // ✅ NEW: sort provider table client-side
  const sortedProviders = [...providerSummary].sort((a, b) => {
    const dir = providerSort.direction === 'asc' ? 1 : -1;
    if (typeof a[providerSort.key] === 'string') {
      return dir * a[providerSort.key].localeCompare(b[providerSort.key]);
    }
    return dir * (a[providerSort.key] - b[providerSort.key]);
  });

  const handleProviderSort = (key) => {
    setProviderSort(prev => ({
      key,
      direction: prev.key === key && prev.direction === 'desc' ? 'asc' : 'desc'
    }));
  };

  const ProviderSortIcon = ({ field }) => {
    if (providerSort.key !== field) return <span style={{ color: '#888' }}> ↕</span>;
    return <span> {providerSort.direction === 'asc' ? '↑' : '↓'}</span>;
  };

  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day   = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year  = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const mins  = String(date.getMinutes()).padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${mins}`;
  };

  const copyToClipboard = (text, label) => {
    navigator.clipboard.writeText(text);
    alert(`${label} copied: ${text}`);
  };

  const sortData = (key) => {
    const direction = sortConfig.key === key && sortConfig.direction === "asc" ? "desc" : "asc";
    const sorted = [...gameData].sort((a, b) => {
      if (key === "amount") return direction === "asc" ? a.amount - b.amount : b.amount - a.amount;
      return direction === "asc"
        ? new Date(a.createdAt) - new Date(b.createdAt)
        : new Date(b.createdAt) - new Date(a.createdAt);
    });
    setGameData(sorted);
    setSortConfig({ key, direction });
  };

  const SortIcon = ({ field }) => {
    if (sortConfig.key !== field) return <span style={{ color: '#888' }}> ↕</span>;
    return <span> {sortConfig.direction === 'asc' ? '↑' : '↓'}</span>;
  };

  const getTypeStyle = (action, type) => {
    if (action === 'win')   return { color: '#16a34a' };
    if (type === 'refund')  return { color: '#0284c7' };
    if (type === 'reject' || type === 'rollback') return { color: '#dc2626' };
    return { color: '#000' };
  };

  const MyPaginate = styled(ReactPaginate).attrs({ activeClassName: "active" })`
    margin: 0.5rem 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style-type: none;
    padding: 0;
    gap: 4px;
    li a { border-radius: 6px; padding: 3px 9px; border: 1px solid #334155; cursor: pointer; color: #000; font-size: 12px; }
    li.active a { background: #f59e0b; border-color: #f59e0b; color: #000; font-weight: 700; }
    li.disabled a { color: #aaa; cursor: default; }
  `;

  const thStyle = {
    color: '#000', background: '#fff',
    cursor: 'pointer', whiteSpace: 'nowrap',
    fontWeight: '600', fontSize: '12px',
    padding: '6px 8px',
  };

  const rangeButtons = ['today', 'weekly', 'monthly', 'custom'];

  // ── Compact stat card config ────────────────────────────────────────────
  const statCards = [
    { label: 'Total Records', value: summary.totalCount, color: '#000' },
    { label: 'Total Bet',     value: `৳${summary.totalBet?.toLocaleString()}`, color: '#000' },
    { label: 'Total Win',     value: `৳${summary.totalWin?.toLocaleString()}`, color: '#16a34a' },
    {
      label: 'Net P/L',
      value: `${summary.netProfitLoss >= 0 ? '+' : ''}৳${summary.netProfitLoss?.toLocaleString()}`,
      color: summary.netProfitLoss >= 0 ? '#16a34a' : '#dc2626',
    },
  ];

  // ── Compact input style (shared, small footprint on mobile) ─────────────
  const compactInputStyle = {
    background: '#fff', color: '#000', border: '1px solid #334155',
    fontSize: '12px', padding: '4px 6px', height: '30px',
  };

  return (
    <>
      <Navbar /><Chatbox /><HeaderRight /><LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">

            {/* ── Header ── */}
            <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
             
              <div className="d-flex gap-2"> 
                <Link to="/casino-summery" className="btn btn-outline-secondary btn-sm active">Casino</Link>
                <Link to="/exchange-summery" className="btn btn-outline-secondary btn-sm">Lucky</Link>
                <Link to="/NineWicket" className="btn btn-outline-secondary btn-sm">9Wicket</Link>
              </div>
            </div>

            {/* ── Date Range Buttons ── */}
            <div className="mb-2 d-flex gap-2 flex-wrap">
              {rangeButtons.map(r => (
                <button key={r}
                  onClick={() => handleRangeClick(r)}
                  style={{
                    padding: '4px 10px', borderRadius: '20px',
                    cursor: 'pointer', fontSize: '12px', fontWeight: '600',
                    background: activeRange === r ? '#f59e0b' : '#fff', color: '#000',
                    border: '1px solid #e2e8f0',
                  }}>
                  {r.charAt(0).toUpperCase() + r.slice(1)}
                </button>
              ))}
            </div>

            {/* ── Custom Date (wraps on mobile instead of clipping) ── */}
            {activeRange === 'custom' && (
              <div className="mb-2 d-flex align-items-center" style={{ flexWrap: 'wrap', gap: '6px' }}>
                <input type="date" value={startDate}
                  onChange={e => setStartDate(e.target.value)}
                  style={{
                    ...compactInputStyle,
                    width: '132px', minWidth: '132px', maxWidth: '132px',
                    flexShrink: 0, flexGrow: 0,
                    borderRadius: '4px', boxSizing: 'border-box', display: 'block',
                  }} />
                <span style={{ color: '#000', fontSize: '12px', flexShrink: 0 }}>→</span>
                <input type="date" value={endDate}
                  onChange={e => setEndDate(e.target.value)}
                  style={{
                    ...compactInputStyle,
                    width: '132px', minWidth: '132px', maxWidth: '132px',
                    flexShrink: 0, flexGrow: 0,
                    borderRadius: '4px', boxSizing: 'border-box', display: 'block',
                  }} />
                <button
                  onClick={() => { currentPage.current = 1; fetchData(startDate, endDate, false, gameName, provider); }}
                  className="btn btn-sm"
                  style={{ background: '#f59e0b', color: '#000', fontWeight: '700', fontSize: '12px', flexShrink: 0, height: '30px' }}>
                  Search
                </button>
              </div>
            )}

            {/* ── Filters ── */}
            <div className="row mb-2 g-2 align-items-end">
              <div className="col-6 col-md-4">
                <label style={{ color: '#000', fontSize: '11px', marginBottom: '2px', display: 'block' }}>Game Name</label>
                <input type="text" value={gameName}
                  onChange={e => setGameName(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleSearch()}
                  placeholder="e.g. Sweet Bonanza..."
                  className="form-control form-control-sm"
                  style={compactInputStyle} />
              </div>
              <div className="col-6 col-md-4">
                <label style={{ color: '#000', fontSize: '11px', marginBottom: '2px', display: 'block' }}>Provider</label>
                <input type="text" value={provider}
                  onChange={e => setProvider(e.target.value)}
                  onKeyDown={e => e.key === 'Enter' && handleSearch()}
                  placeholder="e.g. Pragmatic Play..."
                  className="form-control form-control-sm"
                  style={compactInputStyle} />
              </div>
              <div className="col-6 col-md-2">
                <button onClick={handleSearch} className="btn btn-sm w-100"
                  style={{ background: '#f59e0b', color: '#000', fontWeight: '700', fontSize: '12px', height: '30px' }}>
                  🔍 Search
                </button>
              </div>
              <div className="col-6 col-md-2">
                <button onClick={handleClearSearch} className="btn btn-sm w-100"
                  style={{ background: '#fff', color: '#000', border: '1px solid #334155', fontSize: '12px', height: '30px' }}>
                  ✕ Clear
                </button>
              </div>
            </div>

            {/* ── Active Filters ── */}
            {(gameName || provider) && (
              <div className="mb-2" style={{ fontSize: '11px', color: '#000' }}>
                🔍 Filtering by:
                {gameName && <span className="ms-2 badge" style={{ background: '#78350f', color: '#fff' }}>Game: {gameName}</span>}
                {provider && <span className="ms-2 badge" style={{ background: '#1e3a5f', color: '#fff' }}>Provider: {provider}</span>}
              </div>
            )}

            {/* ── Compact Summary Strip ── */}
            <div
              className="mb-2 d-flex flex-wrap"
              style={{
                background: '#fff',
                border: '1px solid #e2e8f0',
                borderRadius: '10px',
                overflow: 'hidden',
              }}
            >
              {statCards.map((c, i) => (
                <div
                  key={c.label}
                  className="flex-fill text-center"
                  style={{
                    minWidth: '95px',
                    padding: '6px 8px',
                    borderRight: i < statCards.length - 1 ? '1px solid #f1f5f9' : 'none',
                  }}
                >
                  <div style={{ color: '#94a3b8', fontSize: '10px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.02em' }}>
                    {c.label}
                  </div>
                  <div style={{ color: c.color, fontSize: '14px', fontWeight: '700', lineHeight: '1.3' }}>
                    {c.value}
                  </div>
                </div>
              ))}
            </div>

            {/* ── Nav Tabs: Provider Breakdown / Transaction Details ── */}
            <ul className="nav nav-tabs mb-0" style={{ borderBottom: '1px solid #e2e8f0' }}>
              <li className="nav-item">
                <button
                  onClick={() => setActiveTab('provider')}
                  className="nav-link"
                  style={{
                    border: 'none',
                    borderBottom: activeTab === 'provider' ? '2px solid #f59e0b' : '2px solid transparent',
                    color: activeTab === 'provider' ? '#000' : '#64748b',
                    fontWeight: activeTab === 'provider' ? '700' : '600',
                    fontSize: '12px',
                    background: 'transparent',
                    padding: '7px 12px',
                  }}
                >
                   Provider History
                  {sortedProviders.length > 0 && (
                    <span className="ms-2 badge" style={{ background: '#f1f5f9', color: '#475569' }}>
                      {sortedProviders.length}
                    </span>
                  )}
                </button>
              </li>
              <li className="nav-item">
                <button
                  onClick={() => setActiveTab('detail')}
                  className="nav-link"
                  style={{
                    border: 'none',
                    borderBottom: activeTab === 'detail' ? '2px solid #f59e0b' : '2px solid transparent',
                    color: activeTab === 'detail' ? '#000' : '#64748b',
                    fontWeight: activeTab === 'detail' ? '700' : '600',
                    fontSize: '12px',
                    background: 'transparent',
                    padding: '7px 12px',
                  }}
                >
                  📋 Transaction Details
                  {gameData.length > 0 && (
                    <span className="ms-2 badge" style={{ background: '#f1f5f9', color: '#475569' }}>
                      {gameData.length}
                    </span>
                  )}
                </button>
              </li>
            </ul>

            {/* ── Tab Content ── */}
            <div
              className="card mb-3"
              style={{ background: '#fff', border: '1px solid #e2e8f0', borderTop: 'none', borderRadius: '0 0 12px 12px' }}
            >
              <div className="card-body p-0">

                {/* ── Provider Breakdown ── */}
                {activeTab === 'provider' && (
                  sortedProviders.length > 0 ? (
                    <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                      <table className="table table-hover mb-0" style={{ color: '#000', width: 'max-content', minWidth: '100%' }}>
                        <thead style={{ borderBottom: '2px solid #e2e8f0' }}>
                          <tr>
                            {[
                              { key: 'provider',      label: 'Provider' },
                              { key: 'totalRounds',   label: 'Rounds' },
                              { key: 'totalBet',      label: 'Total Bet' },
                              { key: 'totalWin',      label: 'Total Win' },
                              { key: 'totalRefund',   label: 'Refund' },
                              { key: 'netProfitLoss', label: 'Net P/L' },
                            ].map(col => (
                              <th key={col.key}
                                onClick={() => handleProviderSort(col.key)}
                                style={thStyle}>
                                {col.label} <ProviderSortIcon field={col.key} />
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {sortedProviders.map((p, i) => (
                            <tr key={i} style={{ borderBottom: '1px solid #f1f5f9' }}>
                              <td style={{ fontWeight: '600', color: '#000', fontSize: '12px', whiteSpace: 'nowrap', padding: '5px 8px' }}>{p.provider}</td>
                              <td style={{ color: '#000', fontSize: '12px', whiteSpace: 'nowrap', padding: '5px 8px' }}>{p.totalRounds?.toLocaleString()}</td>
                              <td style={{ color: '#000', fontSize: '12px', whiteSpace: 'nowrap', padding: '5px 8px' }}>৳{p.totalBet?.toLocaleString()}</td>
                              <td style={{ color: '#16a34a', fontSize: '12px', whiteSpace: 'nowrap', padding: '5px 8px' }}>৳{p.totalWin?.toLocaleString()}</td>
                              <td style={{ color: '#0284c7', fontSize: '12px', whiteSpace: 'nowrap', padding: '5px 8px' }}>৳{p.totalRefund?.toLocaleString()}</td>
                              <td style={{ fontWeight: '700', fontSize: '12px', whiteSpace: 'nowrap', padding: '5px 8px', color: p.netProfitLoss >= 0 ? '#16a34a' : '#dc2626' }}>
                                {p.netProfitLoss >= 0 ? '+' : ''}৳{p.netProfitLoss?.toLocaleString()}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-center py-4" style={{ color: '#555' }}>No provider data found</div>
                  )
                )}

                {/* ── Transaction Details ── */}
                {activeTab === 'detail' && (
                  loading ? (
                    <div className="text-center p-4" style={{ color: '#555' }}>Loading...</div>
                  ) : (
                    <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                      <table className="table table-hover mb-0" style={{ color: '#000', width: 'max-content', minWidth: '100%' }}>
                        <thead style={{ borderBottom: '2px solid #e2e8f0' }}>
                          <tr>
                            <th style={thStyle} onClick={() => sortData("createdAt")}>
                              Date <SortIcon field="createdAt" />
                            </th>
                            <th style={thStyle} onClick={() => sortData("amount")}>
                              Amount <SortIcon field="amount" />
                            </th>
                            <th style={thStyle}>Action</th>
                            <th style={thStyle}>Type</th>
                            <th style={thStyle}>Game</th>
                            <th style={thStyle}>Provider</th>
                            <th style={thStyle}>Player ID</th>
                            <th style={thStyle}>Session ID</th>
                            <th style={thStyle}>Round ID</th>
                            <th style={thStyle}>Transaction ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {gameData.length > 0 ? (
                            gameData.map((item, index) => (
                              <tr key={index} style={{ borderBottom: '1px solid #f1f5f9' }}>
                                <td style={{ fontSize: '12px', color: '#000', whiteSpace: 'nowrap', padding: '5px 8px' }}>{formatDate(item.createdAt)}</td>
                                <td style={{ whiteSpace: 'nowrap', padding: '5px 8px' }}>
                                  <span style={{ ...getTypeStyle(item.action, item.type), fontWeight: '600', fontSize: '12px' }}>
                                    ৳{item.amount?.toFixed(2)}
                                  </span>
                                </td>
                                <td style={{ whiteSpace: 'nowrap', padding: '5px 8px' }}>
                                  <span style={{
                                    ...getTypeStyle(item.action, item.type),
                                    padding: '2px 8px', borderRadius: '10px',
                                    fontSize: '11px', fontWeight: '600',
                                    background: '#f1f5f9'
                                  }}>
                                    {item.action}
                                  </span>
                                </td>
                                <td style={{ color: '#555', fontSize: '12px', whiteSpace: 'nowrap', padding: '5px 8px' }}>{item.type}</td>
                                <td style={{ fontSize: '12px', color: '#000', maxWidth: '160px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', padding: '5px 8px' }}>{item.gameName || '—'}</td>
                                <td style={{ fontSize: '12px', color: '#000', fontWeight: '600', whiteSpace: 'nowrap', padding: '5px 8px' }}>{item.provider || '—'}</td>
                                {[
                                  { val: item.player_id,      label: 'Player ID' },
                                  { val: item.session_id,     label: 'Session ID' },
                                  { val: item.round_id,       label: 'Round ID' },
                                  { val: item.transaction_id, label: 'Transaction ID' }
                                ].map(({ val, label }) => (
                                  <td key={label} style={{ fontSize: '11px', whiteSpace: 'nowrap', padding: '5px 8px' }}>
                                    <span style={{ color: '#555' }}>{val?.substring(0, 8)}...</span>
                                    <button
                                      onClick={() => copyToClipboard(val, label)}
                                      style={{
                                        background: 'none', border: 'none',
                                        cursor: 'pointer', marginLeft: '4px', fontSize: '12px'
                                      }}
                                      title={`Copy ${label}`}>
                                      📋
                                    </button>
                                  </td>
                                ))}
                              </tr>
                            ))
                          ) : (
                            <tr>
                              {/* ✅ Fix: colSpan 10 (was 9) */}
                              <td colSpan="10" className="text-center py-4" style={{ color: '#555' }}>
                                No data found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )
                )}

              </div>
            </div>

            {/* ── Pagination (only relevant to Transaction Details tab) ── */}
            {activeTab === 'detail' && (
              <MyPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                marginPagesDisplayed={2}
                forcePage={currentPage.current - 1}
              />
            )}

          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default BetSummery;